// extracted by mini-css-extract-plugin
export var content = "popup-module--content--476a6";
export var dismissCheckbox = "popup-module--dismissCheckbox--ae96b";
export var dismissMessage = "popup-module--dismissMessage--637be";
export var dismissMessageContainer = "popup-module--dismissMessageContainer--2afc9";
export var message = "popup-module--message--dc707";
export var overlay = "popup-module--overlay--f6bca";
export var popup = "popup-module--popup--3e26c";
export var title = "popup-module--title--db93c";